import { observable } from 'mobx';

export const SubscriptionTrackerStore = observable({
  isVerifying: false,
  showPaypalBox: false
});
